module.exports = __webpack_public_path__ + "images/root/mainVisual_appeal_sp_8bc3667ffd8cc6f6859f24001dd06082.png";